import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "d-flex align-center" }
const _hoisted_2 = { class: "info mt-4 sub" }
const _hoisted_3 = { class: "info mt-2" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = {
  class: "checkbox-group",
  style: {"pointer-events":"none"}
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "checkbox-group__label mt-4" }, "Количественные цели этапа", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "checkbox-group__label mt-4" }, "Качественные цели этапа", -1)

import { useUiStore } from '@/stores/ui';
import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'TheInfoDrawer',
  setup(__props) {

const uiStore = useUiStore()

const checked = computed(() => {
  if (uiStore.infoDrawer.stageTasks) {
    return new Set(uiStore.infoDrawer.stageTasks.map((item: any) => item.id))
  }
  return null
})


return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_v_navigation_drawer = _resolveComponent("v-navigation-drawer")!

  return (_openBlock(), _createBlock(_component_v_navigation_drawer, {
    modelValue: _unref(uiStore).infoDrawer.open,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(uiStore).infoDrawer.open) = $event)),
    width: "500",
    location: "right",
    temporary: "",
    class: "info-drawer"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("h3", null, _toDisplayString(_unref(uiStore).infoDrawer.title), 1),
        _createVNode(_component_v_btn, {
          icon: "mdi-close",
          flat: "",
          size: "small",
          class: "ml-auto",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(uiStore).infoDrawer.open = false)),
          style: {"opacity":"0.6"}
        })
      ]),
      _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(uiStore).infoDrawer.subtitle), 1),
      _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(uiStore).infoDrawer.content), 1),
      (_unref(uiStore).infoDrawer.checklist)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _hoisted_6,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(uiStore).infoDrawer.checklist.filter((item) => item.type === 'quantity'), (item) => {
                return (_openBlock(), _createBlock(_component_v_checkbox, {
                  "model-value": _unref(checked) && _unref(checked).has(item.id),
                  label: item.title,
                  color: "primary",
                  "hide-details": "",
                  class: _normalizeClass({ dark: !item.checked })
                }, null, 8, ["model-value", "label", "class"]))
              }), 256)),
              _hoisted_7,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(uiStore).infoDrawer.checklist.filter((item) => item.type === 'quality'), (item) => {
                return (_openBlock(), _createBlock(_component_v_checkbox, {
                  "model-value": _unref(checked) && _unref(checked).has(item.id),
                  label: item.title,
                  color: "primary",
                  "hide-details": "",
                  class: _normalizeClass({ dark: !item.checked })
                }, null, 8, ["model-value", "label", "class"]))
              }), 256))
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})